import { configureStore, isPlain } from '@reduxjs/toolkit';
import { isValidElement } from 'react';
import dayjs from 'dayjs';
import reducers from 'services/redux/reducers';
import dataMiddleware from 'services/redux/data/middleware';
import cartMiddleware from 'services/redux/cart/middleware';

// Dates and rendered alerts are existing state contracts. Treat them as opaque
// leaves during development checks until those consumers use serializable data.
const isLegacyValue = ( value ) => {
	return dayjs.isDayjs( value ) || isValidElement( value );
};

export const createAppStore = ( preloadedState ) => {
	return configureStore({
		reducer: reducers,
		preloadedState,
		// Preserve synchronous subscriber notifications used by existing helpers.
		enhancers: ( getDefaultEnhancers ) => {
			return getDefaultEnhancers({ autoBatch: false });
		},
		middleware: ( getDefaultMiddleware ) => {
			return getDefaultMiddleware({
				serializableCheck: {
					isSerializable: ( value ) => {
						return isPlain( value ) || isLegacyValue( value );
					},
					getEntries: ( value ) => {
						return isLegacyValue( value ) ? [] : Object.entries( value );
					},
				},
				immutableCheck: {
					ignoredPaths: [ 'data.alert' ],
				},
			}).concat( dataMiddleware, cartMiddleware );
		},
	});
};
